<template>
  <div class="dashboard">
    <Nav />
    <div class="nav-spacer" />
    <b-container class="dashboard-container">
      <div class="custom-headline headline" v-text="$ml.get('Greeting')"></div>
      <div class="quick-info">
        <div v-if="distance !== 0" v-html="$ml.get('Distance')"></div>
        <div v-if="latestPoints !== ''" v-html="$ml.get('LastSlide')"></div>
        <div
          v-if="distance === 0 && latestPoints === ''"
          v-text="$ml.get('notYet')"
        ></div>
        <div class="button-group">
          <button
            v-if="configurations.length < 3"
            class="btn start-btn"
            style="margin-bottom: 10px"
            @click="selectAndGo(configurations.length)"
            v-text="$ml.get('btnNew')"
          ></button>
          <button
            class="btn abort-btn"
            @click="goTo('/highscores')"
            v-text="$ml.get('btnHighscores')"
          ></button>
        </div>
      </div>
    </b-container>
    <div class="dashboard-configs">
      <div class="container configs-container">
        <div
          class="custom-headline configs-headline"
          v-text="$ml.get('generalTitle')"
        ></div>
        <div class="configs-description" v-text="$ml.get('generalText')"></div>
        <div class="dashboard-tiles-wrapper">
          <Tile
            v-for="(config, index) in tileConfigsSpree"
            :key="config.name + index"
            :name="config.name"
            :music="config.music"
            :speed="config.speed"
            :index="index"
            @select="goTo('konfigurator', config.name)"
            @delete="$bvModal.show('confirm-modal')"
          />
        </div>
      </div>
    </div>
    <div class="dashboard-description">
      <div class="container description-container">
        <div
          class="custom-headline description-headline"
          v-text="$ml.get('description')"
        ></div>
        <div class="box-container">
          <div class="box">
            <!-- <img src="../assets/tile_01.jpg" alt="Schritt 1" /> -->
            <div class="step1 img"></div>
            <div class="box-headline" v-text="$ml.get('step1Title')"></div>
            <div v-text="$ml.get('step1Text')"></div>
          </div>
          <div class="box">
            <!-- <img src="../assets/tile_02.jpg" alt="Schritt 2" /> -->
            <div class="step2 img"></div>
            <div class="box-headline" v-text="$ml.get('step2Title')"></div>
            <div v-text="$ml.get('step2Text')"></div>
          </div>
          <div class="box">
            <!-- <img src="../assets/tile_03.jpg" alt="Schritt 3" /> -->
            <div class="step3 img"></div>
            <div class="box-headline" v-text="$ml.get('step3Title')"></div>
            <div v-text="$ml.get('step3Text')"></div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="footer-center">
      <Footer />
    </div>
    <b-modal
      id="confirm-modal"
      :title="$ml.get('askTitle')"
      centered
      hide-footer
      @ok="deleteSelectedConfig"
    >
      <template slot="default" slot-scope="{ ok, cancel }">
        <div>
          <div v-html="$ml.get('DeleteAsk')"></div>
          <div class="footer-buttons">
            <div class>
              <button
                class="btn cancel-button"
                @click="cancel()"
                v-html="$ml.get('btnCancel')"
              ></button>
            </div>
            <div class>
              <button
                class="btn start-btn"
                @click="ok()"
                v-text="$ml.get('btnConfirm')"
              ></button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Tile from "../components/ConfigTile";
import Footer from "../components/Footer";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { MLBuilder } from "vue-multilanguage";

export default {
  name: "Dashboard",
  components: { Nav, Tile, Footer },
  data() {
    return {
      distance: 0,
      latestPoints: "",
      slideDistanceUrl: "/api/getSlideDistanceForUser",
      lastPointsUrl: "/api/getLastScoreForUser",
    };
  },
  computed: {
    ...mapGetters("configurations", [
      "configurations",
      "pending",
      "tileConfigsSpree",
      "selectedConfig",
    ]),
    ...mapGetters("authentication", ["name"]),
    nameOfSelectedConfig() {
      if (
        this.selectedConfig !== null &&
        this.configurations.length > this.selectedConfig
      )
        return this.configurations[this.selectedConfig].config_name;
      else return "";
    },
    mlGreeting() {
      return new MLBuilder("greeting").with("name", this.name);
    },
    mlLastSlide() {
      return new MLBuilder("lastSlide").with("latestPoints", this.latestPoints);
    },
    mlDistance() {
      return new MLBuilder("distance").with("distance", this.distance);
    },
    mlDeleteAsk() {
      return new MLBuilder("deleteAsk").with(
        "nameOfSelectedConfig",
        this.nameOfSelectedConfig
      );
    },
  },
  async mounted() {
    try {
      this.loadUserData();
      await this.loadConfigurations();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    ...mapActions("configurations", [
      "loadConfigurations",
      "selectConfigForEdit",
      "deleteSelectedConfig",
    ]),
    selectAndGo(index) {
      this.selectConfigForEdit(index);
      this.$router.push("/konfigurator");
    },
    goTo(route, name) {
      if (typeof name !== "undefined" && name !== "") {
        this.$router.push({ path: route, query: { overview: "true" } });
      } else {
        this.$router.push(route);
      }
    },
    async loadUserData() {
      try {
        const self = this;
        let slide_name = "ProSlide";
        const [pointResponse, distanceResponse] = await Promise.all([
          this.axios.get(self.lastPointsUrl, {
            params: { slide_name },
          }),
          this.axios.get(self.slideDistanceUrl, {
            params: { slide_name },
          }),
        ]);
        if (pointResponse.data.data.score !== null) {
          this.latestPoints = pointResponse.data.data.score;
        } else {
          this.latestPoints = "";
        }
        this.distance = distanceResponse.data.data.distance;
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped>
.quick-info .button-group {
  max-width: 450px;
}

.button-group {
  padding-top: 10px;
}

.button-group {
  display: flex;
  flex-direction: column;
  width: 315px;
  /*height: 40px;*/
}

.dashboard-configs {
  margin-top: 80px;
  padding-top: 10px;
  background: rgba(1, 120, 183, 0.2);
  color: white;
}

.dashboard-configs .configs-container,
.container.description-container {
  display: flex;
  flex-direction: column;
}

.configs-headline,
.description-headline {
  font-size: 2.5rem;
}

.configs-description {
  max-width: 530px;
  align-self: center;
}

.dashboard-tiles-wrapper {
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  justify-content: center;
}

.dashboard-description {
  margin-top: 20px;
}

.box {
  width: 300px;
  padding: 15px;
}

.box-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.box img {
  width: 100%;
  height: auto;
  padding-bottom: 20px;
}

.box .img {
  width: 100%;
  padding-top: 100%; /*trick for aspect ratio 1:1 */
  margin-bottom: 20px;
}

.step1 {
  background: url("../assets/tile_01.jpg");
  background-size: cover;
}
.step2 {
  background: url("../assets/tile_02.jpg");
  background-size: cover;
}
.step3 {
  background: url("../assets/tile_03.jpg");
  background-size: cover;
}

.box-headline {
  font-weight: bold;
  padding-bottom: 10px;
}

.cancel-button {
  color: black;
  background: none;
  border: 1px solid rgba(1, 120, 183, 0.3);
  margin-right: 10px;
}

.cancel-button:hover,
.cancel-button:focus {
  border: 1px solid rgba(1, 120, 183, 0.5);
  background-color: rgba(1, 120, 183, 0.3);
}

.modal-left,
.modal-right {
  width: 50%;
}

.modal-left {
  text-align: right;
}

.modal-right {
  text-align: left;
}

@media (max-width: 576px) {
  .box-container {
    flex-direction: column;
  }
  .box {
    align-self: center;
  }
}
</style>
